import produce from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';
import { UserType } from 'types/user.type';
import * as AuthService from 'services/auth';
import { updateUserPassword, updateUserProfile } from 'services/myAccount';
import { resetPassword } from 'services/external/resetPassword';
import { message } from 'antd';
import { getApiLanguageValue } from 'utils/functionUtils';
import { RootModel } from '../models';
import { storeName as verificationTokenModelStoreName } from './verificationToken.model';
import { storeName as layoutModelStoreName } from './layout.model';

export const storeName = 'userModel';

type UserModelTypes = {
  user: UserType;
  loading: boolean;
};

const initialState: UserModelTypes = {
  user: undefined,
  loading: false,
};

export const userModel: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setUser: produce((state, payload: boolean) => {
      state.user = payload;
    }),
    updateLoading: produce((state, payload) => {
      state.loading = payload;
    }),
  },
  effects: (dispatch: RematchDispatch) => ({
    async getUserDetailAsync() {
      return AuthService.getUserDetail().then((res: any) => {
        const { data } = res;
        data.permissions = data.roles.flatMap((r: any) => r.permissions).map((p: any) => p.name);
        this.setUser(data);
        return data;
      });
    },

    async updatePassword(payload) {
      this.updateLoading(true);

      try {
        const res = await updateUserPassword(payload);
        message.success('Change password success.');

        return res;
      } catch (e) {
        const { message: messageError } = e.response.data;

        if (messageError !== '') {
          message.error(messageError);
        } else {
          message.error('Failed to update password. Please check again your password!');
        }
      } finally {
        this.updateLoading(false);
      }
    },

    async updateUserProfile(payload, state: RootModel) {
      this.updateLoading(true);
      const { locale } = state[layoutModelStoreName];

      try {
        const res = await updateUserProfile(payload, getApiLanguageValue(locale));
        this.getUserDetailAsync();
        dispatch[verificationTokenModelStoreName].getUserVerifyingEmail();
        message.success('Change information success.');
        return res;
      } catch (e) {
        console.error(e);
        const { message: messageError } = e.response.data;

        if (messageError !== '') {
          message.error(messageError);
        } else {
          message.error('Failed to change info user!');
        }
      } finally {
        this.updateLoading(false);
      }
    },

    async resetPassword(payload, state: RootModel) {
      this.updateLoading(true);
      try {
        const res = await resetPassword(payload);
        return res;
      } catch (e) {
        console.error(e);
        const { message: messageError } = e.response.data;

        if (messageError !== '') {
          message.error(messageError);
        } else {
          message.error('Failed to send link reset password. Please check and try again.');
        }
      } finally {
        this.updateLoading(false);
      }
    },
  }),
});

export default userModel;
